import moment from 'moment';

export const isoDateFormat = 'YYYY-MM-DD HH:mm:ss';

export function formatFromDate(dateToFormat: Date | string): string {
  return moment(dateToFormat).local().format('MMM DD, YYYY HH:mm');
}

export function formatFromDateWithSeconds(dateToFormat: Date | string): string {
  return moment(dateToFormat).local().format('MMM DD, YYYY HH:mm:ss');
}

export function formatFromString(dateToFormat: string): string {
  return moment(dateToFormat).local().format('MMM DD, YYYY HH:mm');
}

export function formatFromDateWithTimezone(dateToFormat: Date | string): string {
  const momentDate = moment(dateToFormat).local();
  const formattedDate = momentDate.format('MMM DD, YYYY HH:mm');
  const timezoneOffset = momentDate.format('Z'); // Returns "+05:00" or "-05:00"
  // Convert "+05:00" to "UTC+5" format for readability
  const shortOffset = timezoneOffset.replace(':00', '').replace('+', 'UTC+').replace('-', 'UTC-');
  return `${formattedDate} ${shortOffset}`;
}

export const dateToUtcIsoString = (date: Date): string => {
  const momentDate = moment(date);
  const utcDate = new Date(
    Date.UTC(
      momentDate.year(),
      momentDate.month(),
      momentDate.date(),
      momentDate.hour(),
      momentDate.minute(),
      momentDate.second(),
      momentDate.millisecond()
    )
  );
  return utcDate.toISOString();
};
